export enum LogType {
  API_OVERTIME = 'API_OVERTIME',
  API_ERROR = 'API_ERROR',
}
